import * as React from 'react';

import { IAuthService } from '../../services/Interfaces/IAuthService';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { AppActionCreators, ApplicationState, AppState } from '../../store';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { ScaleLoader } from 'react-spinners';
import { Button, Grid, IconButton, List, ListItem } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import { withRouter } from 'react-router';
import moment from 'moment';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import CheckIcon from '@material-ui/icons/Check';
import { IAppUserService } from '../../services/Interfaces/IAppUserService';
import { IOrganizationService } from '../../services/Interfaces/IOrganizationService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CountryCodeEnum } from '../../helpers/Constants';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import CaseNewInNotificationItem from './CaseNewInNotificationItem';
import { NotificationType, UserNotification } from '../../interfaces/UserNotificationsUpdate';

export interface ExternalCaseNewInNotificationProps {
  onClick?: () => void;
}

type CaseNewInNotificationProps = { appState: AppState } & typeof AppActionCreators &
  RouteComponentProps &
  ExternalCaseNewInNotificationProps;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICaseNewInNotificationState {}

class CaseNewInNotification extends React.PureComponent<
  CaseNewInNotificationProps,
  ICaseNewInNotificationState
> {
  private authService!: IAuthService;
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appUserService!: IAppUserService;
  private organizationService!: IOrganizationService;
  private notifications: UserNotification[] = [];

  static contextType = ApplicationContext;

  state = {} as ICaseNewInNotificationState;

  public render() {
    this.authService = (this.context as AppContext).authenticationService;
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appUserService = (this.context as AppContext).appUserService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.notifications = this.props.appState.userNotifications.filter((notification: UserNotification) => notification.type === NotificationType.Case);

    return (
      <React.Fragment>
        {this.notifications.length == 0? (
        <div className="text-center">
          <div className="avatar-icon-wrapper  m-0">
            <div className="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper  m-0 d-140">
              {/* <FontAwesomeIcon icon={['far', 'user']} className="d-flex align-self-center display-1 " /> */}
              <FontAwesomeIcon
                icon={['far', 'folder-open']}
                className="d-flex align-self-center display-1 "
              />
            </div>
          </div>
        </div>
      ) : null} 
        {this.notifications.length !== 0 ? (
          <List className="p-0">
            {this.notifications.map((item, index) => (
                <ListItem divider key={index} style={{ 
                  backgroundColor: !item.read ? '#f7f7fc' : 'inherit'              
                  }}>
                    <CaseNewInNotificationItem                    
                        {...this.props}                    
                        item = {{
                            dateCreated: new Date(item.dateCreation), // Ensure Date object
                            type: 'caseNewIn',
                            entity: item,
                            isInPopup: false
                        }}
                        index= {index}>
                    </CaseNewInNotificationItem>
                  
                </ListItem>
              )
            )}
          </List>
        ) : null}
      </React.Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: ExternalCaseNewInNotificationProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  AppActionCreators,
  mergeProps
)(withRouter(CaseNewInNotification as any));
